import { message } from 'antd';

/**
 * 复制文本的自定义Hook
 * @param {Object} options - 配置项
 * @param {Function} options.onSuccess - 复制成功的回调
 * @param {Function} options.onError - 复制失败的回调
 * @returns {Function} copyText - 复制文本的函数
 */
export const useCopy = (options = {}) => {
    const {
        onSuccess = () => message.success('复制成功'),
        onError = () => message.error('复制失败，请手动复制'),
    } = options;

    const copyText = async (text) => {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
                onSuccess();
                return;
            }

            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.cssText = 'position:fixed;left:-999999px;top:-999999px;';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            textArea.remove();

            if (successful) {
                onSuccess();
            } else {
                onError();
            }
        } catch (error) {
            console.error('复制失败:', error);
            onError();
        }
    };

    return copyText;
};
